import {UsersList} from '@hconnect/adminconsole/src/pages/UsersList/UsersList'
import {User} from '@hconnect/apiclient'
import {trackEvent} from '@hconnect/common/logging/Analytics'
import {PermissionTypes} from '@hconnect/uikit'
import {useEffect} from 'react'
import {useSelector} from 'react-redux'

import {withRouteRequiringPermission} from '../../Molecules/PermissionBoundary'
import {usePermissions} from '../../Permissions'
import {AppState} from '../../Root.store'

const UsersListPage = () => {
  const {adminConsoleGrantedPermissionTypes} = usePermissions()
  const loggedInUserProfile = useSelector<AppState, User | null>(
    (state) => state.userProfile.userProfile
  )
  useEffect(() => {
    trackEvent('hubCustomerAdminAccessed', {userId: loggedInUserProfile?.user_id})
  }, [loggedInUserProfile?.user_id])
  return (
    <UsersList
      loggedInUserPermissions={adminConsoleGrantedPermissionTypes}
      loggedInUserProfile={loggedInUserProfile}
    />
  )
}

export const ROUTE = '/users'
export default withRouteRequiringPermission({
  path: ROUTE,
  label: 'User Management',
  labelKey: 'userManagement.navigationLabel',
  routeProps: {exact: true},
  featureToggleName: 'EnableUserManagementIntegration',
  permissions: [PermissionTypes.VIEW_USERS, PermissionTypes.CHANGE_USERS]
})(UsersListPage)
